import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StakeholderReferenceRoutingModule } from './stakeholderreference-routing.module';
import { GenericReferenceComponent } from './components/GenericReference/GenericReference.component';
import { GenericReferenceContainerComponent } from './containers/GenericReference/GenericReference.component';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { StoreModule } from '@ngrx/store';

import * as fromStakeholderReference from './states/+stakeholderreference/stakeholderreference.reducer';
import { StakeholderReferenceEffects } from './states/+stakeholderreference/stakeholderreference.effects';

import { StakeholderReferenceFacade } from './states/+stakeholderreference/stakeholderreference.facade';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StakeholderReferenceRoutingModule,
    AngularMaterialModule,
    EpimsDashboardNavModule,
    HttpClientModule,
    SpinnersModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    StoreModule.forFeature(
      fromStakeholderReference.STAKEHOLDERREFERENCE_FEATURE_KEY,
      fromStakeholderReference.reducer
    ),
    EffectsModule.forFeature([StakeholderReferenceEffects]),
  ],
  declarations: [GenericReferenceContainerComponent, GenericReferenceComponent],
  providers: [StakeholderReferenceFacade],
  entryComponents: [],
})
export class StakeholderreferenceModule {}
